import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from '../../global';
import { RootState } from '../../store';
import { accountsSelectors } from './companyAccounts.state';
import { CompanyAccount } from './companyAccounts.types';
import { companiesSelectors } from '../companies/companies.state';

export const useAccountsState = (): RootState['companyAccounts'] => {
  const accounts = useSelector<RootState, RootState['companyAccounts']>(state => state.companyAccounts);

  useDebugValue(accounts);

  return accounts;
};

export const useAccountsValues = (): CompanyAccount[] => {
  const accounts = useSelector<RootState, RootState['companyAccounts']>(state => state.companyAccounts);

  const result = accountsSelectors.selectAll(accounts);

  useDebugValue(result);

  return result;
};

export const useAccountById = (id: string): AsyncEntity<CompanyAccount> | null => {
  const accounts = useSelector<RootState, RootState['companyAccounts']>(state => state.companyAccounts);

  const result = accountsSelectors.selectById(accounts, id) || null;

  useDebugValue(result);

  return result;
};

export type UseAccountsByCompanyId = (params: { companyId: string }) => CompanyAccount[];

export const useAccountsByCompanyId: UseAccountsByCompanyId = ({ companyId }) => {
  const state = useSelector<RootState, RootState['companies']>(state => state.companies);

  const company = companiesSelectors.selectById(state, companyId) || null;

  if (company) {
    return company.accounts;
  }
  return [];
};
